import { render, staticRenderFns } from "./SorItemVisualisation.vue?vue&type=template&id=1b3e4bfa"
import script from "./SorItemVisualisation.vue?vue&type=script&lang=js"
export * from "./SorItemVisualisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports